import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=624f7a66&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=624f7a66&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=624f7a66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624f7a66",
  null
  
)

export default component.exports